var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "custom-box",
        {
          class: { "mobile-custom-box": _vm.isMobile },
          attrs: { title: _vm.$t("editAnnouncement"), visible: _vm.dialogShow },
          on: {
            "update:visible": function($event) {
              _vm.dialogShow = $event
            },
            close: function($event) {
              return _vm.clearData(true)
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "ruleForm",
              staticClass: "popover",
              class: { "mobile-form": _vm.isMobile },
              attrs: {
                "label-position": "left",
                rules: _vm.rules,
                model: _vm.paramsData,
                "label-width": "130px"
              }
            },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: { prop: "is_pause", label: _vm.$t("announcementType") }
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      attrs: { disabled: "" },
                      on: { change: _vm.pauseChange },
                      model: {
                        value: _vm.paramsData.pause,
                        callback: function($$v) {
                          _vm.$set(_vm.paramsData, "pause", $$v)
                        },
                        expression: "paramsData.pause"
                      }
                    },
                    [
                      _c("el-radio", { attrs: { label: 0 } }, [
                        _vm._v(_vm._s(_vm.$t("normalAnnouncement")))
                      ]),
                      _c("el-radio", { attrs: { label: 1 } }, [
                        _vm._v(_vm._s(_vm.$t("serverStopAnnouncement")))
                      ]),
                      _c("el-radio", { attrs: { label: 2 } }, [
                        _vm._v(_vm._s(_vm.$t("newServerOpen")))
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: { prop: "label", label: _vm.$t("identifier") }
                },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "flex-1",
                      attrs: {
                        disabled: "",
                        filterable: "",
                        placeholder: _vm.$t("pleaseChoose")
                      },
                      on: { change: _vm.labelChange },
                      model: {
                        value: _vm.paramsData.label,
                        callback: function($$v) {
                          _vm.$set(_vm.paramsData, "label", $$v)
                        },
                        expression: "paramsData.label"
                      }
                    },
                    _vm._l(_vm.tagggList, function(item) {
                      return _c("el-option", {
                        key: item.label,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem lodingItems",
                  attrs: { prop: "priority", label: _vm.$t("priorityValue") }
                },
                [
                  _c("el-input", {
                    staticClass: "flex-1 no-number",
                    attrs: {
                      disabled: "",
                      type: "number",
                      clearable: "",
                      filterable: "",
                      placeholder: _vm.$t("pleaseInputPriorityValue")
                    },
                    model: {
                      value: _vm.paramsData.priority,
                      callback: function($$v) {
                        _vm.$set(_vm.paramsData, "priority", _vm._n($$v))
                      },
                      expression: "paramsData.priority"
                    }
                  }),
                  _c("div", { staticClass: "lodingItemTips" }, [
                    _vm._v(" " + _vm._s(_vm.$t("priorityTip")) + " ")
                  ])
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem lodingItems",
                  attrs: {
                    prop: "force_push",
                    label: _vm.$t("isStrongReminder")
                  }
                },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "flex-1",
                      attrs: {
                        disabled: "",
                        clearable: "",
                        filterable: "",
                        placeholder: _vm.$t("pleaseChoose")
                      },
                      model: {
                        value: _vm.paramsData.force_push,
                        callback: function($$v) {
                          _vm.$set(_vm.paramsData, "force_push", $$v)
                        },
                        expression: "paramsData.force_push"
                      }
                    },
                    _vm._l(_vm.whetherNot, function(item) {
                      return _c("el-option", {
                        key: item.label,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  ),
                  _c("div", { staticClass: "lodingItemTips" }, [
                    _vm._v(" " + _vm._s(_vm.$t("strongReminderTip")) + " ")
                  ])
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: { label: _vm.$t("startUnlimited") }
                },
                [
                  _c("el-switch", {
                    attrs: {
                      "active-text": _vm.$t("open"),
                      disabled: "",
                      "inactive-text": _vm.$t("close"),
                      "active-color": "#13ce66"
                    },
                    on: {
                      change: function($event) {
                        return _vm.isS($event, "start_time")
                      }
                    },
                    model: {
                      value: _vm.isStart,
                      callback: function($$v) {
                        _vm.isStart = $$v
                      },
                      expression: "isStart"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: {
                    prop: "start_time",
                    rules: !_vm.isStart
                      ? _vm.rules.start_time
                      : [{ require: false }],
                    label: _vm.$t("startTime")
                  }
                },
                [
                  _c("el-date-picker", {
                    staticClass: "flex-1 ",
                    attrs: {
                      disabled: "",
                      "popper-class": "no-atTheMoment",
                      type: "datetime",
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                      placeholder: _vm.$t("pleaseChoose"),
                      align: "right"
                    },
                    model: {
                      value: _vm.paramsData.start_time,
                      callback: function($$v) {
                        _vm.$set(_vm.paramsData, "start_time", $$v)
                      },
                      expression: "paramsData.start_time"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: { label: _vm.$t("endUnlimited") }
                },
                [
                  _c("el-switch", {
                    attrs: {
                      disabled: "",
                      "active-text": _vm.$t("open"),
                      "inactive-text": _vm.$t("close"),
                      "active-color": "#13ce66"
                    },
                    on: {
                      change: function($event) {
                        return _vm.isS($event, "end_time")
                      }
                    },
                    model: {
                      value: _vm.isEnd,
                      callback: function($$v) {
                        _vm.isEnd = $$v
                      },
                      expression: "isEnd"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: {
                    prop: "end_time",
                    rules: !_vm.isEnd
                      ? _vm.rules.end_time
                      : [{ require: false }],
                    label: _vm.$t("endTime")
                  }
                },
                [
                  _c("el-date-picker", {
                    staticClass: "flex-1 ",
                    attrs: {
                      "popper-class": "no-atTheMoment",
                      disabled: "",
                      type: "datetime",
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                      placeholder: _vm.$t("pleaseChoose"),
                      align: "right"
                    },
                    model: {
                      value: _vm.paramsData.end_time,
                      callback: function($$v) {
                        _vm.$set(_vm.paramsData, "end_time", $$v)
                      },
                      expression: "paramsData.end_time"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: { label: _vm.$t("serverScope") }
                },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "operationFrame-entity",
                      attrs: {
                        disabled: "",
                        filterable: "",
                        multiple: "",
                        "collapse-tags": "",
                        clearable: "",
                        placeholder: _vm.$t("pleaseChoose")
                      },
                      model: {
                        value: _vm.paramsData.server_range,
                        callback: function($$v) {
                          _vm.$set(_vm.paramsData, "server_range", $$v)
                        },
                        expression: "paramsData.server_range"
                      }
                    },
                    _vm._l(_vm.serverList, function(item) {
                      return _c(
                        "el-option",
                        {
                          key: item.serverID,
                          attrs: {
                            label: item.serverName,
                            value: item.serverID
                          }
                        },
                        [
                          _c("div", { staticClass: "serverOption" }, [
                            _c("div", [_vm._v(_vm._s(item.serverName))]),
                            _c("div", { staticStyle: { color: "red" } }, [
                              _vm._v(
                                _vm._s(
                                  item.is_recomm == 1 ? _vm.$t("recommend") : ""
                                )
                              )
                            ])
                          ])
                        ]
                      )
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: { prop: "channel", label: _vm.$t("channelId") }
                },
                [
                  _c("el-input", {
                    staticClass: "flex-1",
                    attrs: {
                      disabled: "",
                      placeholder: _vm.$t("channelIdPlaceholder")
                    },
                    model: {
                      value: _vm.paramsData.channel,
                      callback: function($$v) {
                        _vm.$set(_vm.paramsData, "channel", $$v)
                      },
                      expression: "paramsData.channel"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  key: "channel_list",
                  staticClass: "lodingItem",
                  attrs: { label: _vm.$t("channelId") }
                },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "operationFrame-entity",
                      attrs: {
                        disabled: "",
                        "collapse-tags": "",
                        multiple: "",
                        placeholder: _vm.$t("pleaseChoose")
                      },
                      model: {
                        value: _vm.paramsData.channel_list,
                        callback: function($$v) {
                          _vm.$set(_vm.paramsData, "channel_list", $$v)
                        },
                        expression: "paramsData.channel_list"
                      }
                    },
                    _vm._l(_vm.channellAllList, function(item) {
                      return _c("el-option", {
                        key: item.channel_mark,
                        attrs: {
                          label: item.channel_name,
                          value: item.channel_mark
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm.paramsData.pause !== 0
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "lodingItem",
                      attrs: {
                        prop: "pause_start_time",
                        label:
                          _vm.paramsData.pause == 1
                            ? _vm.$t("expectedServerOpenTime")
                            : _vm.$t("serverOpenTime")
                      }
                    },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          disabled: "",
                          "popper-class": "no-atTheMoment",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          type: "datetime",
                          placeholder: _vm.$t("pleaseChoose")
                        },
                        model: {
                          value: _vm.paramsData.pause_start_time,
                          callback: function($$v) {
                            _vm.$set(_vm.paramsData, "pause_start_time", $$v)
                          },
                          expression: "paramsData.pause_start_time"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.paramsData.pause === 1
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "lodingItem",
                      attrs: {
                        prop: "show_switch",
                        label: _vm.$t("toggleButtonShow")
                      }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "flex-1",
                          attrs: {
                            disabled: "",
                            clearable: "",
                            filterable: "",
                            placeholder: _vm.$t("pleaseChoose")
                          },
                          model: {
                            value: _vm.paramsData.show_switch,
                            callback: function($$v) {
                              _vm.$set(_vm.paramsData, "show_switch", $$v)
                            },
                            expression: "paramsData.show_switch"
                          }
                        },
                        _vm._l(_vm.whetherNot, function(item) {
                          return _c("el-option", {
                            key: item.label,
                            attrs: { label: item.label, value: item.value }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.paramsData.pause === 0
                ? _c(
                    "el-row",
                    { staticStyle: { width: "100%" } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "lodingItem",
                          attrs: { prop: "main_content" }
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.addContent }
                            },
                            [_vm._v(_vm._s(_vm.$t("addContent")))]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._l(_vm.paramsData.main_content, function(domain, index) {
                return _c(
                  "div",
                  { key: index + "k", staticClass: "main_contentClass" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "lodingItem-operationFrame flex",
                        staticStyle: { "margin-bottom": "20px" }
                      },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass:
                              "lodingItem contentValitem lodingItemt",
                            attrs: {
                              prop: "main_content." + index + ".title",
                              rules: _vm.rules.title,
                              label: _vm.$t("title"),
                              "label-width": "60px"
                            }
                          },
                          [
                            _c("el-input", {
                              staticClass: "operationFrame-entity",
                              attrs: {
                                clearable: "",
                                placeholder: _vm.$t("pleaseInputTitle")
                              },
                              model: {
                                value: domain.title,
                                callback: function($$v) {
                                  _vm.$set(domain, "title", $$v)
                                },
                                expression: "domain.title"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass:
                              "lodingItem contentValitem lodingItemt",
                            attrs: {
                              prop: "main_content." + index + ".language",
                              rules: _vm.rules.language,
                              label: _vm.$t("language"),
                              "label-width": "60px"
                            }
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticClass: "flex-1",
                                attrs: {
                                  clearable: "",
                                  filterable: "",
                                  placeholder: _vm.$t("pleaseChoose")
                                },
                                model: {
                                  value: domain.language,
                                  callback: function($$v) {
                                    _vm.$set(domain, "language", $$v)
                                  },
                                  expression: "domain.language "
                                }
                              },
                              _vm._l(_vm.langList, function(item) {
                                return _c("el-option", {
                                  key: item.label,
                                  attrs: {
                                    label: item.label,
                                    value: item.value
                                  }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        ),
                        _vm.paramsData.main_content.length > 1 &&
                        !_vm.paramsData.pause !== 0
                          ? _c("el-button", {
                              staticStyle: { margin: "0 0 10px 10px" },
                              attrs: {
                                size: "mini",
                                type: "danger",
                                circle: "",
                                icon: "el-icon-delete"
                              },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.removeContent(domain)
                                }
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "flex lodingItem-title first_box",
                        class: { "mobile-content-header": _vm.isMobile },
                        staticStyle: {
                          "margin-bottom": "20px",
                          width: "100%",
                          "align-items": "center"
                        }
                      },
                      [
                        _vm._v(_vm._s(_vm.$t("content")) + ": "),
                        _vm.paramsData.pause === 0
                          ? _c(
                              "div",
                              {
                                staticClass: "flex",
                                class: { "mobile-tag-list": _vm.isMobile },
                                staticStyle: { "padding-left": "20px" }
                              },
                              _vm._l(_vm.tagList, function(items, indexs) {
                                return _c(
                                  "div",
                                  {
                                    key: indexs,
                                    staticClass: "addtag",
                                    on: {
                                      click: function($event) {
                                        return _vm.addtag(items.content, index)
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(items.name))]
                                )
                              }),
                              0
                            )
                          : _vm._e()
                      ]
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticStyle: { width: "100%" },
                        attrs: {
                          prop: "main_content." + index + ".content",
                          rules: _vm.rules.content
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            type: "textarea",
                            autosize: { minRows: 2, maxRows: 12 },
                            placeholder: _vm.$t("pleaseInputContent")
                          },
                          model: {
                            value: domain.content,
                            callback: function($$v) {
                              _vm.$set(domain, "content", $$v)
                            },
                            expression: "domain.content "
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              })
            ],
            2
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { round: "" },
                  on: {
                    click: function($event) {
                      return _vm.hiad()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("cancel")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "warning", round: "" },
                  on: {
                    click: function($event) {
                      return _vm.clearData()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("reset")))]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    loading: _vm.reqLoading,
                    round: ""
                  },
                  on: {
                    click: function($event) {
                      return _vm.dataFormSubmit("ruleForm")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("save")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }